import type { Messages } from '../catalogue.en'

export const leads: Partial<Messages> = {
  'lead.title': 'Заявки',
  'lead.subtitle': 'Регистрация пациента до того, как карта станет активной',
  'lead.tableLabel': 'Заявки пациентов',
  'lead.loading': 'Загрузка заявок',
  'lead.loadFailed': 'Не удалось загрузить заявки.',
  'lead.retry': 'Повторить',
  'lead.empty': 'Заявок пока нет',
  'lead.emptyDetail': 'Создайте заявку, когда новый пациент впервые обращается в клинику.',
  'lead.publicEntryTitle': 'Публичная регистрация пациентов',
  'lead.publicEntryDetail': 'Поделитесь этой общей страницей с пациентами, которые регистрируются сами.',
  'lead.publicEntryOpen': 'Открыть публичную регистрацию',
  'lead.columnPatient': 'Пациент',
  'lead.columnCode': 'Код заявки',
  'lead.columnContact': 'Контакт',
  'lead.columnSource': 'Источник',
  'lead.columnEntry': 'Способ входа',
  'lead.columnAcquisition': 'Привлечение',
  'lead.columnResponsible': 'Куратор',
  'lead.columnStatus': 'Статус',
  'lead.columnCreated': 'Создана',
  'lead.columnExpires': 'Срок ссылки',
  'lead.columnActions': 'Действия',
  'lead.statusIssued': 'Ожидает пациента',
  'lead.statusSubmitted': 'Отправлена',
  'lead.statusRevoked': 'Отозвана',
  'lead.sourcePhone': 'Телефон',
  'lead.sourceEmail': 'Электронная почта',
  'lead.sourceMessenger': 'Мессенджер',
  'lead.sourceWebsite': 'Веб-сайт',
  'lead.sourceTelegram': 'Telegram',
  'lead.sourceReferral': 'Направление',
  'lead.sourceOther': 'Другой',
  'lead.entryInvited': 'Личное приглашение',
  'lead.entryPublic': 'Общедоступная страница',
  'lead.newTitle': 'Новая заявка',
  'lead.newDetail': 'Создайте предварительную карту пациента и выдайте личную ссылку для регистрации.',
  'lead.language': 'Предпочитаемый язык',
  'lead.country': 'Страна проживания',
  'lead.source': 'Канал обращения',
  'lead.comment': 'Краткий комментарий',
  'lead.curator': 'Ответственный врач или координатор',
  'lead.protocol': 'Протокол регистрации',
  'lead.expiresAt': 'Срок действия ссылки',
  'lead.create': 'Создать заявку',
  'lead.creating': 'Создание…',
  'lead.selectionRequired': 'Выберите куратора и протокол регистрации.',
  'lead.expiryRequired': 'Выберите срок действия ссылки в будущем.',
  'lead.optionsLoading': 'Загрузка кураторов и протоколов…',
  'lead.optionsFailed': 'Не удалось загрузить кураторов или протоколы регистрации.',
  'lead.noProtocols': 'Нет опубликованного протокола регистрации пациентов.',
  'lead.saveFailed': 'Не удалось создать заявку.',
  'lead.idempotencyConflict': 'Эта попытка создания уже была использована с другими данными заявки.',
  'lead.createdTitle': 'Заявка создана',
  'lead.createdDetail': 'Скопируйте эту личную ссылку сейчас. Core никогда не хранит саму ссылку.',
  'lead.link': 'Ссылка для регистрации пациента',
  'lead.copyLink': 'Скопировать ссылку',
  'lead.linkCopied': 'Ссылка скопирована',
  'lead.copyFailed': 'Не удалось скопировать ссылку. Выделите её и скопируйте вручную.',
  'lead.openLink': 'Открыть регистрацию',
  'lead.rotateNamed': 'Выдать новую ссылку для {name}',
  'lead.claim': 'Взять',
  'lead.claimNamed': 'Взять заявку пациента {name}',
  'lead.claiming': 'Назначение…',
  'lead.claimFailed': 'Не удалось взять заявку. Возможно, её уже назначили другому сотруднику.',
  'lead.claimSelected': 'Взять выделенные ({count})',
  'lead.claimedCount': 'Заявок взято: {count}.',
  'lead.claimedBefore': 'До этого взято заявок: {count}.',
  'lead.rotateTitle': 'Выдать новую ссылку для регистрации',
  'lead.rotateDetail': 'Предыдущая ссылка перестаёт работать сразу.',
  'lead.rotate': 'Выдать новую ссылку',
  'lead.rotating': 'Выдача…',
  'lead.rotateFailed': 'Не удалось выдать новую ссылку.',
  'lead.notRotatable': 'Эта заявка больше не ожидает регистрации.',
  'lead.discardTitle': 'Отменить черновик заявки?',
  'lead.discardDetail': 'Введённая здесь информация не сохранена.',
  'lead.keepEditing': 'Продолжить редактирование',
  'lead.discard': 'Отменить',
  'lead.submissionsTitle': 'Регистрация пациента',
  'lead.submissionsDetail': 'Данные первичного опроса, заполненные пациентом, хранятся вместе с той версией протокола, которая была заполнена.',
  'lead.submissionsLoading': 'Загрузка ответов регистрации',
  'lead.submissionsFailed': 'Не удалось загрузить ответы регистрации.',
  'lead.submissionsEmpty': 'Ответ пациента на анкету регистрации не записан.',
  'lead.answeredBy': 'Ответил',
  'lead.authoredAt': 'Отправлено',
  'lead.authorPatient': 'Пациент',
  'lead.authorRepresentative': 'Представитель',
  'lead.schemaUnavailable': 'Этот клиент не может отобразить исторический протокол.',
  'lead.valueYes': 'Да',
  'lead.valueNo': 'Нет',
  'lead.representativesTitle': 'Представители',
  'lead.representativesLoading': 'Загрузка представителей',
  'lead.representativesFailed': 'Не удалось загрузить представителей.',
  'lead.representativesEmpty': 'Представитель не записан.',
  'lead.representativeParent': 'Родитель',
  'lead.representativeGuardian': 'Опекун',
  'lead.representativeAuthorized': 'Уполномоченное лицо',
  'lead.representativeOther': 'Другое',
  'lead.verificationSelfDeclared': 'Со слов заявителя',
  'lead.verificationVerified': 'Подтверждено',
  'lead.verificationRevoked': 'Отменено',
  'lead.representativeRelationship': 'Родство:',
  'lead.authorityScope': 'Полномочия:',
  'lead.authoritySubmitOnboarding': 'Отправка регистрации пациента',
  'lead.areaNavigation': 'Разделы заявок',
  'lead.sectionLeads': 'Заявки',
  'lead.sectionLeadsDetail': 'Обращения и регистрация пациентов',
  'lead.sectionPartners': 'Реферальные партнёры',
  'lead.sectionPartnersDetail': 'Источники, ссылки и вознаграждения',
  'referralPartner.title': 'Реферальные партнёры',
  'referralPartner.subtitle': 'Юридические субъекты, участвующие в реферальной программе клиники',
  'referralPartner.loading': 'Загрузка реферальных партнёров',
  'referralPartner.loadFailed': 'Не удалось загрузить реферальных партнёров.',
  'referralPartner.tableLabel': 'Справочник реферальных партнёров',
  'referralPartner.empty': 'Реферальных партнёров пока нет',
  'referralPartner.emptyDetail': 'Подключите существующий юридический субъект, чтобы выдать приватную ссылку.',
  'referralPartner.columnName': 'Партнёр',
  'referralPartner.columnKind': 'Тип',
  'referralPartner.columnStatus': 'Статус',
  'referralPartner.columnValidity': 'Срок действия',
  'referralPartner.columnAgreement': 'Договор',
  'referralPartner.columnLink': 'Персональная ссылка',
  'referralPartner.columnVerified': 'Подтверждённые лиды',
  'referralPartner.columnCompleted': 'Завершили регистрацию',
  'referralPartner.columnPoints': 'Доступные баллы',
  'referralPartner.columnMoney': 'Одобрено денег',
  'referralPartner.columnActions': 'Действия',
  'referralPartner.openNamed': 'Открыть {name}',
  'referralPartner.kindOrganization': 'Организация',
  'referralPartner.kindIndividual': 'Физическое лицо',
  'referralPartner.status.active': 'Активен',
  'referralPartner.status.suspended': 'Приостановлен',
  'referralPartner.status.closed': 'Закрыт',
  'referralPartner.panelEyebrow': 'Реферальный партнёр',
  'referralPartner.edit': 'Редактировать',
  'referralPartner.editIdentity': 'Редактировать юридические данные',
  'referralPartner.legalEntity': 'Юридический субъект',
  'referralPartner.selectLegalEntity': 'Выберите юридический субъект',
  'referralPartner.identityManagedSeparately': 'Название, налоговые данные, адрес и контакты редактируются в разделе юридических субъектов.',
  'referralPartner.archive': 'Архивировать',
  'referralPartner.restore': 'Восстановить',
  'referralPartner.contactTitle': 'Данные юридического субъекта',
  'referralPartner.kind': 'Тип юридического субъекта',
  'referralPartner.taxId': 'Налоговый номер',
  'referralPartner.taxType': 'Тип налогового номера',
  'referralPartner.phone': 'Телефон',
  'referralPartner.email': 'Электронная почта',
  'referralPartner.website': 'Сайт',
  'referralPartner.address': 'Адрес',
  'referralPartner.addressLine2': 'Вторая строка адреса',
  'referralPartner.city': 'Город',
  'referralPartner.postalCode': 'Почтовый индекс',
  'referralPartner.country': 'Страна',
  'referralPartner.linkTitle': 'Приватная реферальная ссылка',
  'referralPartner.link': 'Реферальная ссылка',
  'referralPartner.linkActive': 'Активна',
  'referralPartner.linkInactive': 'Отозвана или не выпущена',
  'referralPartner.copyLink': 'Скопировать реферальную ссылку',
  'referralPartner.openLink': 'Открыть реферальную ссылку',
  'referralPartner.copied': 'Реферальная ссылка скопирована.',
  'referralPartner.copyFailed': 'Не удалось скопировать ссылку. Выделите и скопируйте её вручную.',
  'referralPartner.rotate': 'Сменить ссылку',
  'referralPartner.revoke': 'Отозвать ссылку',
  'referralPartner.performanceTitle': 'Атрибуция и балансы',
  'referralPartner.pointsAvailable': 'Доступные баллы',
  'referralPartner.pointsPending': 'Баллы на рассмотрении',
  'referralPartner.pointsRedeemed': 'Использованные баллы',
  'referralPartner.pointsReversed': 'Сторнированные баллы',
  'referralPartner.balancePending': 'Ожидает решения',
  'referralPartner.balanceApproved': 'Одобрено',
  'referralPartner.balancePaid': 'Выплачено',
  'referralPartner.balanceReversed': 'Сторнировано',
  'referralPartner.agreementsTitle': 'История договоров',
  'referralPartner.agreementsEmpty': 'Договор не записан.',
  'referralPartner.agreementCode': 'Номер договора',
  'referralPartner.agreementStatus': 'Статус договора',
  'referralPartner.addAgreement': 'Добавить договор',
  'referralPartner.rulesTitle': 'Правила вознаграждения',
  'referralPartner.rulesEmpty': 'Нет активных правил вознаграждения.',
  'referralPartner.trigger.verified_lead': 'Подтверждённый лид',
  'referralPartner.trigger.onboarding_submitted': 'Завершённая регистрация',
  'referralPartner.triggerLabel': 'Событие',
  'referralPartner.valueKind': 'Вид вознаграждения',
  'referralPartner.valueKindPoints': 'Баллы',
  'referralPartner.valueKindMoney': 'Деньги',
  'referralPartner.rewardPoints': 'Баллы: {amount}',
  'referralPartner.amount': 'Сумма',
  'referralPartner.currency': 'Валюта',
  'referralPartner.effectiveFrom': 'Действует с',
  'referralPartner.effectiveTo': 'Действует до',
  'referralPartner.ruleEnabled': 'Включено',
  'referralPartner.ruleDisabled': 'Отключено',
  'referralPartner.editRule': 'Редактировать правило',
  'referralPartner.saveRule': 'Сохранить новую редакцию',
  'referralPartner.addRule': 'Добавить правило',
  'referralPartner.rewardsTitle': 'Реестр вознаграждений',
  'referralPartner.rewardsEmpty': 'Вознаграждений пока нет.',
  'referralPartner.rewardState.pending': 'Ожидает решения',
  'referralPartner.rewardState.approved': 'Одобрено',
  'referralPartner.rewardState.rejected': 'Отклонено',
  'referralPartner.rewardState.paid': 'Выплачено',
  'referralPartner.rewardState.reversed': 'Сторнировано',
  'referralPartner.approve': 'Одобрить',
  'referralPartner.reject': 'Отклонить',
  'referralPartner.markPaid': 'Отметить выплаченным',
  'referralPartner.reverse': 'Сторнировать',
  'referralPartner.failure.invalid': 'Проверьте введённые значения и попробуйте снова.',
  'referralPartner.failure.conflict': 'Запись изменилась или действие больше недоступно. Свежие данные загружены, а введённые значения сохранены.',
  'referralPartner.failure.forbidden': 'У вас нет права выполнять это действие.',
  'referralPartner.failure.unavailable': 'Реферальный сервис недоступен. Попробуйте снова, не закрывая эту панель.',
  'referralPartner.editTitle': 'Редактирование реферального партнёра',
  'referralPartner.createTitle': 'Новый реферальный партнёр',
  'referralPartner.legalName': 'Юридическое название',
  'referralPartner.statusLabel': 'Статус программы',
  'referralPartner.statusHistoryNote': 'Приостановка или закрытие прекращает новые атрибуции. Существующие атрибуции и история вознаграждений сохраняются.',
  'referralPartner.validFrom': 'Действует с',
  'referralPartner.validTo': 'Действует до',
  'referralPartner.comment': 'Комментарий',
  'referralPartner.save': 'Сохранить',
  'referralPartner.saving': 'Сохранение…',
  'referralPartner.cancel': 'Отмена',
  'referralPartner.confirm.archive': 'Архивировать этого реферального партнёра?',
  'referralPartner.confirm.restore': 'Восстановить этого реферального партнёра?',
  'referralPartner.confirm.rotate': 'Сменить эту приватную реферальную ссылку?',
  'referralPartner.confirm.revoke': 'Отозвать эту приватную реферальную ссылку?',
  'referralPartner.confirm.reward': 'Подтвердить изменение вознаграждения?',
  'referralPartner.confirmDescription.archive': 'Активная ссылка будет отозвана. Существующие атрибуции и история вознаграждений сохранятся.',
  'referralPartner.confirmDescription.restore': 'Исторические данные сохранятся. После восстановления смените ссылку, чтобы выдать новую активную ссылку.',
  'referralPartner.confirmDescription.rotate': 'Текущая ссылка перестанет принимать новые атрибуции. Существующие атрибуции и история вознаграждений сохранятся.',
  'referralPartner.confirmDescription.revoke': 'Ссылка перестанет принимать новые атрибуции. Существующие атрибуции и история вознаграждений сохранятся.',
  'referralPartner.confirmDescription.reward': 'Будет добавлено событие в реестр; предыдущая история вознаграждения не перезаписывается.',
  'referralPartner.reason': 'Причина',
  'referralPartner.confirm': 'Подтвердить',
  'referralPartner.confirmedReason': 'Подтверждено в справочнике реферальных партнёров.',
  'referralPartner.agreementState.active': 'Активен',
  'referralPartner.agreementState.closed': 'Закрыт',
  'referralPartner.validityOpen': 'без ограничения',
}
